import React from "react";
import Description from "../typography/Description";
import Subtitle from "../typography/Subtitle";
import Title from "../typography/Title";
import { Link } from "react-router-dom";

const CardMini = ({ post }) => {
  const href = `/blog/${post?.slug}`;
  return (
    <Link
      to={href}
      className="group/card flex h-full w-full flex-col gap-6 border-b-2 border-transparent p-4 transition-colors duration-500 ease-linear hover:border-app-400 sm:flex-row"
    >
      <img
        src={post?.coverImage?.asset?.url}
        alt=""
        className="max-h-full w-auto max-w-52 object-cover"
      />
      <div className="flex h-full w-full flex-col justify-center gap-4">
        <Subtitle className="text-left text-gray-350">Blog</Subtitle>
        <Title
          size="sm"
          className="text-left transition-colors duration-500 ease-linear group-hover/card:text-orange-400"
        >
          {post?.title}
        </Title>
        <Description>{post?.description ?? ""}</Description>
      </div>
    </Link>
  );
};

export default CardMini;
